import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class ViewTicketDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <h3 className="mb0 mt40">다수 티켓 상세 정보 조회</h3>
                <div className="blog-post-meta">
                                <span
                                    className="s-post">티켓에 대한 상세 정보를 조회 합니다. 이 API를 이용해 최대 10개의 티켓 정보를 가져올 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v2/providers/travel_backbone_api/apis/ticket-api/v1/deal/{'{dealId}'}/tickets</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/deal/1234567/tickets
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>딜번호</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>ticketNumbers</td>
                            <td>O</td>
                            <td>String</td>
                            <td>티켓번호 리스트</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>redeemable</td>
                            <td>Boolean</td>
                            <td>사용 처리 가능 여부</td>
                        </tr>
                        <tr>
                            <td>ticketNumber</td>
                            <td>String</td>
                            <td>티켓번호</td>
                        </tr>
                        <tr>
                            <td>purchasedAt</td>
                            <td>Date</td>
                            <td>구매완료일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>canceledAt</td>
                            <td>Date</td>
                            <td>취소완료일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>statusType</td>
                            <td>String</td>
                            <td>
                                "CANCEL_COMPLETE" : 취소완료상태<br/>
                                "PURCHASE_COMPLETE" : 구매완료상태
                            </td>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>Long</td>
                            <td>딜번호</td>
                        </tr>
                        <tr>
                            <td>optionId</td>
                            <td>Long</td>
                            <td>옵션번호</td>
                        </tr>
                        <tr>
                            <td>useAmount</td>
                            <td>Long</td>
                            <td>사용 가능 수량</td>
                        </tr>
                        <tr>
                            <td>totalAmount</td>
                            <td>Long</td>
                            <td>총 사용수량</td>
                        </tr>
                        <tr>
                            <td>price</td>
                            <td>Long</td>
                            <td>구매가격</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
           {
                "message": "success",
                "data" : {
                    "8231E1-13000000000768" : {
                        "useAmount" : 0,
                        "totalAmount" : 1,
                        "ticketNumber" : "8231E1-13000000000768",
                        "statusType" : "PURCHASE_COMPLETE",
                        "redeemable" : false,
                        "price" : 0,
                        "optionId" : 53000424937,
                        "dealId" : 6500124650,
                        "purchasedAt" : "2017-05-23 23:19:21",
                        "canceledAt" : null
                    },
                     "8231E1-13000000000769" : {
                        "useAmount" : 0,
                        "totalAmount" : 1,
                        "ticketNumber" : "8231E1-13000000000769",
                        "statusType" : "PURCHASE_COMPLETE",
                        "redeemable" : false,
                        "price" : 0,
                        "optionId" : 53000424937,
                        "dealId" : 6500124650,
                        "purchasedAt" : "2017-05-23 23:19:21",
                        "canceledAt" : null
                    }
                }
            }

                        `}
                    </pre>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketManagementAPI/ViewMutipleTicketDetails.jsx